import styled from 'styled-components';
import { sizes } from 'style';
import { th } from 'style/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media ${sizes.desktop} {
    flex-direction: row;
  }
`;

export const LeftColContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${sizes.desktop} {
    margin-right: 60px;
  }

  @media ${sizes.largeDesktop} {
    margin-right: 100px;
  }
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: 20px;
  }

  > p {
    color: ${th('colors.white')};
  }

  > textarea {
    width: 100%;
    height: 200px;
    border: none;
    font-family: ${th('fonts.body')};
    font-size: 16px;
  }
`;

export const Buttons = styled.div`
  align-self: flex-end;
`;

export const ImageContainer = styled.div`
  > img {
    width: 100%;
    height: auto;
  }

  @media ${sizes.tabletPortrait} {
    width: 80%;
    margin: 0 auto;
  }

  @media ${sizes.tabletLandscape} {
    max-width: 500px;
  }
`;
